import http from '../common/api';
import {ApiSettings} from "application";

const saveMarketingData = async (values) => {

  const {email, rut, phone, name} = values;
  const request = {
    email,
    rut,
    phone,
    'name_lastname': name,
    'profile': false,
    'origin': 'IDAI',
    'recaptcha': values?.recaptcha,
  };

  return await http.put(ApiSettings.saveMarketingUserData, request);
}

export default saveMarketingData;
